function shouldSkipRepeatedAutoSave ({ isAutoSave, configFingerprint, lastFailureFingerprint }) {
  return Boolean(isAutoSave && configFingerprint && configFingerprint === lastFailureFingerprint)
}

function resolveAutoSaveFailureFingerprint ({ isAutoSave, configFingerprint }) {
  if (!isAutoSave) {
    return ''
  }
  return configFingerprint || ''
}

module.exports = {
  shouldSkipRepeatedAutoSave,
  resolveAutoSaveFailureFingerprint
}
